// Test IDs de la conexion con Square (Configuración).

export const PAYMENTS = {
  squareSettingsCard: 'settings-square-card',
  squareConnectButton: 'settings-square-connect-button',
  squareDisconnectButton: 'settings-square-disconnect-button',
  squareConnectedBadge: 'settings-square-connected-badge',
  squareNotConnectedBadge: 'settings-square-not-connected-badge',
  squareEnvironmentBadge: 'settings-square-environment-badge',
  squareBaseUrlWarning: 'settings-square-base-url-warning',
};
